import { Route, Routes } from "react-router-dom";
import LoginPage from "pages/public/login";

import NotFound from "components/layout/notfound";
import useAuthStore from "store/auth";
import AuthPage from "pages/auth";
import PublicPage from "pages/public";
import JoinBasePage from "pages/public/join/base";
import JoinAuthEmailPage from "pages/public/join/email";
import JoinCreatePage from "pages/public/join/create";
import ResetPwdEmailPage from "pages/public/resetPwd/email";
import ResetBasePwdPage from "pages/public/resetPwd/base";
import ResetPwdPage from "pages/public/resetPwd/reset";
import { BaseJoinParamProvider } from "pages/public/join/base/context";
import { BaseResetPwdParamProvider } from "pages/public/resetPwd/base/context";

function App() {
  const isLogin = useAuthStore((state) => state.isLogin);
  return (
    <Routes>
      {/* auth 로그인 필요 : 홈, 회원관리, 객실관리 등*/}
      {isLogin && <Route path="/" element={<AuthPage />} />}

      {/* pablic 로그인 불필요  : 로그인, 회원가입, 비밀번호 찾기*/}
      {!isLogin && (
        <Route path="/" element={<PublicPage />}>
          <Route path="" element={<LoginPage />} />

          {/* 회원가입 */}
          <Route
            path="/join"
            element={
              <BaseJoinParamProvider>
                <JoinBasePage />
              </BaseJoinParamProvider>
            }
          />
          <Route path="/join/email" element={<JoinAuthEmailPage />} />
          {/* <Route path="/join/mail" element={<>메일 인증</>} /> */}
          <Route path="/join/regi" element={<JoinCreatePage />} />

          {/* 비밀번호 설정 */}
          <Route
            path="/resetPwd"
            element={
              <BaseResetPwdParamProvider>
                <ResetBasePwdPage />
              </BaseResetPwdParamProvider>
            }
          />
          <Route path="/resetPwd/email" element={<ResetPwdEmailPage />} />
          <Route path="/resetPwd/reset" element={<ResetPwdPage />} />
        </Route>
      )}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
